import {Add} from '@mui/icons-material'
import {Button} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {ActionDialogWrapper} from '../components'
import {FEATURE_NAMESPACE} from '../consts'
import {useQuestions} from '../hooks'
import {ActionItem} from '../types'

import {ActionsCardContainer} from './ActionsCardContainer'
import {QuestionnaireContainer} from './QuestionnaireContainer'
import {TabSectionContainer, Tab} from './TabSectionContainer'

export enum PlantCardTab {
  Questions,
  Actions
}

type TopicSideCardContainerProps = {
  actions: ActionItem[]
}

export const TopicSideCardContainer: FC<TopicSideCardContainerProps> = ({actions}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const questionList = useQuestions()

  const tabs: Tab<PlantCardTab>[] = [
    {
      index: PlantCardTab.Questions,
      label: t('questionsOverview.title', {questionsCount: questionList.data?.length}),
      component: <QuestionnaireContainer />
    },
    {
      index: PlantCardTab.Actions,
      label: t('actionsCard.title', {actionsCount: actions.length}),
      component: <ActionsCardContainer actions={actions} />
    }
  ]

  return (
    <TabSectionContainer<PlantCardTab>
      tabs={tabs}
      initialTab={PlantCardTab.Questions}
      getTabAction={(tab) =>
        tab === PlantCardTab.Actions && (
          <ActionDialogWrapper
            opener={
              <Button
                sx={{height: 48}}
                variant={'text'}
                startIcon={<Add />}
                data-test-id="add-action"
              >
                {t('addAction.heading')}
              </Button>
            }
          />
        )
      }
    />
  )
}
